/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgSettingsPutScreenShareContent = typeof OrgSettingsPutScreenShareContent[keyof typeof OrgSettingsPutScreenShareContent] | null;


export const OrgSettingsPutScreenShareContent = {
  interviewer_only: 'interviewer_only',
  candidate_only: 'candidate_only',
  all: 'all',
  off: 'off',
} as const;
